module.exports = __webpack_public_path__ + "static/legal-shield-review-ea285c7c9a2ec930fa652d1f73073664.png";